import { kpisIgnoredUsers } from './constants';
import { userDeclaredWorkByMonth } from './userDeclaredWork';

export function getDeclaredWorkForUser(userId) {
    return userDeclaredWorkByMonth.find(record =>
        record.userIds.some(id => Number(id) === Number(userId))
    );
}

export function getTotalDeclaredTaskMinutes(endDate) {
    // Sum available monthly values once per record, even when it has multiple user IDs.
    const taskMinutes = userDeclaredWorkByMonth
        .filter(record => record.userIds.some(id => !kpisIgnoredUsers.includes(Number(id))))
        .map(record => record.months[endDate]?.taskMinutes)
        .filter(minutes => Number.isFinite(minutes));
    if (taskMinutes.length === 0) {
        return null;
    }
    return taskMinutes.reduce((total, minutes) => total + minutes, 0);
}

export function getLinkedUserIds(userId) {
    const record = getDeclaredWorkForUser(userId);
    return [...new Set((record?.userIds ?? [userId]).map(Number))]
        .filter(id => Number.isSafeInteger(id) && id > 0 && !kpisIgnoredUsers.includes(id))
        .sort((a, b) => a - b);
}

export function getTargetUsersMap(usersMap, selectedUserId = null) {
    const userIds = selectedUserId === null ? Object.keys(usersMap) : [selectedUserId];
    return userIds.reduce((targetUsers, userId) => {
        getLinkedUserIds(userId).forEach(id => {
            // Explicitly linked system users may not be in the employee directory.
            targetUsers[id] = usersMap[id] ?? { id };
        });
        return targetUsers;
    }, {});
}

export function getUserOptions(usersMap) {
    return [
        { key: 'ALL', value: 'ALL', text: 'All' },
        ...Object.values(usersMap)
            .map(user => ({
                key: user.id,
                value: Number(user.id),
                text: user.fullName || user.username || String(user.id),
            }))
            .sort((a, b) => a.text.localeCompare(b.text)),
    ];
}
